import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import classes from "./styles.module.scss";
import Heading from "../../components/header";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import PrimaryButton from "../../components/buttons";

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
};

const thTdStyle = {
    border: "1px solid black",
    padding: "8px",
    textAlign: "center",
};

const thStyle = {
    ...thTdStyle,
    backgroundColor: "#f2f2f2",
};

const AttendanceReport = () => {
    const location = useLocation();
    const reportRef = useRef(); // Reference for the table

    console.log(location.state)
    // const generatePDF = () => {
    //     const input = reportRef.current;

    //     html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
    //         const imgData = canvas.toDataURL("image/png");
    //         const pdf = new jsPDF("l", "mm", "a4"); // Landscape mode

    //         const pageWidth = pdf.internal.pageSize.getWidth(); // 297mm
    //         const pageHeight = pdf.internal.pageSize.getHeight(); // 210mm

    //         const imgWidth = pageWidth - 20; // Maintain margins
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

    //         let y = 10; // Initial Y position
    //         let page = 1; // Page counter
    //         let remainingHeight = imgHeight;

    //         while (remainingHeight > 0) {
    //             pdf.addImage(imgData, "PNG", 10, y, imgWidth, Math.min(remainingHeight, pageHeight - 20), 0, -(page - 1) * (pageHeight - 20));
    //             remainingHeight -= pageHeight - 20;
    //             if (remainingHeight > 0) {
    //                 pdf.addPage();
    //                 page++;
    //                 y = 10;
    //             }
    //         }

    //         pdf.save("Attendance_Report.pdf");
    //     });
    // };

    const handlePrint = () => {
        if (!reportRef.current) return;

        const printWindow = window.open("", "", "width=900,height=900");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Attendance Report</title>
                    <style>
                        body { font-family: Arial, sans-serif; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid black; padding: 8px; text-align: center; }
                        th { background-color: #f2f2f2; }
                        img { max-width: 100px; height: auto; }
                    </style>
                </head>
                <body>
                    ${reportRef.current.outerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
        setTimeout(() => {
            document.querySelectorAll("img").forEach((img) => {
                img.src = img.src; // Force reload
            });
        }, 500);
    };


    return (
        <div className={classes.div}>
            {/* <Heading text="Departmental Exam Attendance Report" path="#" /> */}

            <div style={{ margin: "10px", padding: '10px' }}>
                {/* <PrimaryButton buttonText="Generate PDF" backgroundColor="#005ca8" onClick={generatePDF} /> */}
                {/* <PrimaryButton buttonText="Generate PDF" backgroundColor="#005ca8" onClick={() => window.print()} /> */}
                <PrimaryButton buttonText="Generate PDF" backgroundColor="#005ca8" onClick={handlePrint} />
            </div>


            <div ref={reportRef} style={{ margin: "10px", padding: "10px", paddingRight: '20px' }}>
                {/* Time and Room No Row */}
                <table style={tableStyle}>
                    <tbody>
                        <tr>
                            <td style={{ ...thTdStyle, fontWeight: "bold" }}>TIME:</td>
                            <td style={thTdStyle}>{location?.state?.data?.data[0]?.start_time}</td>
                        </tr>
                        <tr>
                            <td style={{ ...thTdStyle, fontWeight: "bold" }}>ROOM NO:</td>
                            <td style={thTdStyle}></td>
                        </tr>
                        <tr>
                            <td colSpan="11" style={{ ...thTdStyle, textAlign: "center", fontWeight: "bold", fontSize: "18px", padding: "10px" }}>
                                DEPARTMENTAL EXAM ATTENDANCE REPORT
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Main Table */}
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>S. NO</th>
                            <th style={thStyle}>ROLL NO</th>
                            <th style={thStyle}>NAME</th>
                            <th style={thStyle}>SERVICE</th>
                            <th style={thStyle}>SUBJECT CODE</th>
                            <th style={thStyle}>SEAT NO</th>
                            <th style={thStyle}>PHOTO</th>
                            <th style={thStyle}>SIGNATURE</th>
                            <th style={thStyle}>SIGNATURE</th>
                            <th style={thStyle}>NO OF BOOKS</th>
                            <th style={thStyle}>MARKS OBTAINED</th>
                            <th style={thStyle}>EXIT TIME</th>
                            <th style={thStyle}>RESULT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {location?.state?.data?.data?.map((a, i) => {
                            const getImageUrl = (imagePath) => {
                                return imagePath?.startsWith("http") ? imagePath : process.env.REACT_APP_IMG_URL + imagePath;
                            };

                            return (
                                <tr key={i}>
                                    <td style={thTdStyle}>{i + 1}</td>
                                    <td style={thTdStyle}>{a?.aadhar}</td>
                                    <td style={thTdStyle}>{a?.name}</td>
                                    <td style={thTdStyle}>{a?.service}</td>
                                    <td style={thTdStyle}>{a?.subCode}</td>
                                    <td style={thTdStyle}></td>
                                    <td style={thTdStyle}>
                                        <img src={getImageUrl(a?.passport)} alt="passport image" style={{ height: '50px', width: '50px' }} />
                                    </td>
                                    <td style={thTdStyle}>
                                        <img src={getImageUrl(a?.signature)} alt="signature" style={{ height: '50px', width: '100px' }} />
                                    </td>
                                    <td style={thTdStyle}></td>
                                    <td style={thTdStyle}></td>
                                    <td style={thTdStyle}></td>
                                    <td style={thTdStyle}></td>
                                    <td style={thTdStyle}></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceReport);
